const CURRENCY_SYMBOLS = {
  NGN: "₦",
  USD: "$",
  EUR: "€",
  GBP: "£",
};

export function formatPackagePrice(amount, currencyCode = "USD") {
  const normalizedAmount = Number(amount);
  const normalizedCurrency = String(currencyCode || "USD").toUpperCase();

  if (!Number.isFinite(normalizedAmount)) {
    return "Price unavailable";
  }

  const minimumFractionDigits =
    normalizedCurrency === "NGN" && Number.isInteger(normalizedAmount) ? 0 : 2;
  const formattedAmount = new Intl.NumberFormat("en-US", {
    minimumFractionDigits,
    maximumFractionDigits: 2,
  }).format(normalizedAmount);

  return `${CURRENCY_SYMBOLS[normalizedCurrency] || ""}${formattedAmount} ${normalizedCurrency}`;
}
